<template>
    <v-container fluid>
      <div id="app ">
        <div style="display:flex; justify-content: space-between;">
          <Breadcrumb class="row justify-content-center mt-4" />
          <span v-if="showLoader">
            <LoaderProgress></LoaderProgress>
          </span>
        </div>
      </div>
      <v-data-table
        ref="theDataTable"
        :headers="headersData"
        :items="sensorMailersData"
        :search="search"
        :items-per-page="15"
        @pagination="pagination = $event"
        :mobile-breakpoint="0"
        fixed-header
        height="400px"
        border-bottom="5px"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
  
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="800px">
              <template v-slot:activator="{ on, attrs }">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-width="50"
                  offset-x
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class=""
                      fab
                      small
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="white">icon-download</v-icon>
                    </v-btn>
                  </template>
  
                  <v-card>
                    <v-divider></v-divider>
  
                    <v-list>
                      <v-list-item>
                        <v-list-item-action>
                          <vue-json-to-csv
                            :json-data="dataDownload"
                            :csv-title="'Sensor Mailer Data'"
                          >
                            <v-btn color="indigo" dark style="">
                              CSV
                            </v-btn>
                          </vue-json-to-csv>
                        </v-list-item-action>
                      </v-list-item>
  
                      <v-list-item>
                        <v-list-item-action>
                          <v-btn @click="createPDF" color="indigo" dark
                            >PDF
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
                <v-btn
                  :disabled="disablewhileProcessing"
                  class="mr-2 ml-4"
                  small
                  fab
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  @click="addDoc()"
                >
                  <v-icon>icon-add</v-icon>
                </v-btn>
              </template>
              <!-- changes -->
              <v-form ref="form">
                <v-card>
                  <v-card-title class="background-blue">
                    <span class="text-h5 icon-white">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-autocomplete
                          :disabled="disableMachine"
                            :items="machineItems"
                            v-model="editedItem.machine_id"
                            prepend-icon="icon-dpimm"
                            @change="assignparam($event)"
                            label="Select Machines(s)*"
                            item-text="machine_name"
                            item-value="id"
                            :rules="selectedItemsRules"
                            required
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-autocomplete
                          :disabled="disableMachine"
                            v-on:click="getAlluserData()"
                            label="Users*"
                            :items="userSelectiondata"
                            item
                            prepend-icon="icon-role"
                            v-model="editedItem.user_id"
                            item-value="user_id"
                            item-text="user_name"
                            required
                            :rules="selectedItemsRules"
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-autocomplete
                            label="Duration*"
                            :items="duration"
                            item
                            prepend-icon="icon-role"
                            v-model="editedItem.duration"
                            item-value="text"
                            item-text="value"
                            required
                            :rules="selectedItemsRules"
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-autocomplete
                            label="Time to Receive Mail*"
                            :items="time_to_receive_mail"
                            item
                            prepend-icon="icon-role"
                            v-model="editedItem.time_to_receive_mail"
                            item-value="text"
                            item-text="value"
                            required
                            :rules="selectedItemsRules"
                          />
                        </v-col>
  
                        <v-col cols="12" sm="6" md="4">
                          <label class="radiolabel">Enable</label>
                          <v-radio-group
                            v-model="editedItem.active"
                            row
                            class="radiogroup"
                          >
                            <v-radio
                              label="Yes"
                              value="Y"
                              @change="changeActivestatus('Y')"
                            ></v-radio>
                            <v-radio
                              label="No"
                              value="N"
                              @change="changeActivestatus('N')"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
  
                  <v-card-actions class="pb-5">
                    <v-spacer></v-spacer>
                    <v-btn rounded color="#FE000C" @click="close">
                      <v-icon left class="icon-white">icon-cancel</v-icon>
                      <span style="color: white;"> Cancel</span>
                    </v-btn>
                    <v-btn rounded color="primary" @click="submitForm()">
                      <v-icon left>icon-availability</v-icon>
                      Submit
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:item.active="{ item }">
          <v-switch
            color="indigo"
            @change="changeStatus(item, item.active)"
            :disabled="disablewhileProcessing"
            false-value="N"
            true-value="Y"
            v-model="item.active"
          ></v-switch>
        </template>
  
        <template
          v-slot:item.actions="{ item }"
          :disabled="disablewhileProcessing"
        >
          <v-icon small class="mr-2" @click="editItem(item)">
            icon-action
          </v-icon>
        </template>

      </v-data-table>
      <div id="sucessAlert">
        <v-alert outlined type="success" text>
          Data Saved successfully.
        </v-alert>
      </div>
      <div id="errorAlert">
        <v-alert outlined type="warning" prominent border="left">
          Error while saving the data.
        </v-alert>
      </div>
    </v-container>
  </template>
  <script>
  import Breadcrumb from "../components/breadcrumbs.vue";
  import LoaderProgress from "../components/progressLoader";
  
  import axios from "axios";
  import VueJsonToCsv from "vue-json-to-csv";
  import jsPDF from "jspdf";
  import "jspdf-autotable";
  import router from "../router";
  
  export default {
    components: {
      VueJsonToCsv,
      Breadcrumb,
      LoaderProgress,
    },
  
    data: () => ({
      duration : [
        { text: '12 Hours', value: '12 Hours' },
        { text: '24 Hours', value: '24 Hours' },
        { text: '5 Days', value: '5 Days' },
        { text: '7 Days', value: '7 Days' },
        { text: '15 Days', value: '15 Days' },
      ],
      time_to_receive_mail : [],
      disableMachine: false,
      disablewhileProcessing: false,
      userSelectiondata: [],
      userSelection: null,
      selectedItemsRules: [(v) => !!v || "At least one option must be selected"],
      showLoader: false,
      isEdit: false,
      machineItems: [],
      dataDownload: [],
      headersData: [],
      sensorMailersData: [],
      userNames: [],
      menu: false,
      search: "",
      dialog: false,
      editedIndex: -1,
      editedItem: {
        id: null,
        machine_id: null,
        user_id: null,
        duration: "",
        time_to_receive_mail: "",
        active: "Y"
      },
      defaultItem: {
        id: null,
        machine_id: null,
        user_id: null,
        duration: "",
        time_to_receive_mail: "",
        active: "Y"
      },

    }),
  
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? "Add New" : "Edit Item";
      },
    },
  
    watch: {
      dialog(val) {
        val || this.close();
      },
    },
  
    created() {
      this.setGridData();
      this.setMachineData();
      this.getAlluserData();
      this.time_to_receive_mail = this.generateTimeSlots();
    },
  
    methods: {

        generateTimeSlots() {
            const times = [];
            
            function formatHour(hour) {
                return hour < 10 ? `0${hour}` : hour;
            }

            times.push('12 AM'); 
            for (let hour = 1; hour <= 11; hour++) {
                times.push(`${formatHour(hour)} AM`);
            }
            
            times.push('12 PM'); 
            for (let hour = 1; hour <= 11; hour++) {
                times.push(`${formatHour(hour)} PM`);
            }

            return times.map((time) => ({
                text: time,
                value: time
            }));
        },

      getAlluserData() {
        try {
          let config = {
            method: "get",
            url: `${this.$config.backend_url}/getAllUserData`,
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          };
          this.noteLastAPICallTime();
          axios(config).then((response) => {
            this.userSelectiondata = response.data.data;
          });
        } catch (error) {
          window.alert("Internal Error");
        }
      },
  
      submitForm() {
        if (this.$refs.form.validate()) {
          this.save();
        } else {
          console.log(this.$refs.form.validate());
          this.dialog = true;
        }
      },
      addDoc() {
        this.disableMachine = false
        this.isEdit = false;
      },

      changeActivestatus(item) {
        document.querySelector("#errorAlert").style.display = "none";
        this.editedItem.enable_flag = item;
      },

      createPDF() {
        let content = this.$refs["theDataTable"];
        let doc = new jsPDF("landscape");
        doc.text(14, 7.5, "Sensor Mailer Data");
        doc.addImage(
          this.getImgUrl1(this.$config.image_inside_pdf),
          "png",
          this.$config.first_dimension_separate_again,
          this.$config.second_dimension_separate,
          this.$config.third_dimension_separate,
          this.$config.fourth_dimension_separate_again
        );
        let columnHeaders = [
          "User Name",
          "Machine(s)",
          "Email",
          "Duration",
          "Time to Receive Mail",
          "Status",
        ];
        let rows = [];
        content.items.forEach((data, index) => {
          if (
            index >= this.pagination.pageStart &&
            index < this.pagination.pageStop
          ) {
            let tempRow = [
              data.username || "",
              data.machine_name || "",
              data.email || "",
              data.duration || "",
              data.time_to_receive_mail || "",
              data.active === "Y" ? "On" : "Off",
            ];
            rows.push(tempRow);
          }
        });
        doc.setFontSize(9);
        doc.autoTable(columnHeaders, rows, { startY: 11.5 });
        let d = new Date();
        doc.save(
          `Sensor_Mailer_Data ${d.toISOString().slice(0, 10) +
            " " +
            d
              .toTimeString()
              .split("(")[0]
              .slice(0, -1)}.pdf`
        );
      },

      setMachineData() {
        this.showLoader = true;
        let config = {
          method: "get",
          url: `${this.$config.backend_url}/getMachineNames`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        };
        this.noteLastAPICallTime();
        axios(config)
          .then((response) => {
            this.showLoader = false;
            console.log("response--getMachineNames", response.data);
            let machineData = response.data.data;
            machineData.sort((first_machine, second_machine) => {
              return this.compareObjects(
                first_machine,
                second_machine,
                "machine_name"
              );
            });
            console.log("cehcking machine dayta=>", machineData);
            this.machineItems = machineData;
          })
          .catch((error) => {
            this.showLoader = false;
            if (error.response && error.response.status === 401) {
              sessionStorage.clear();
              router.push("/login");
            } else {
              alert("internal error");
              console.log("axios error", error.message);
            }
          });
  
        // this.selectProps = ["Nozzle Temperature","Z1 Temperature"]
      },
  
      changeStatus(item, status) {
        let updated_user = sessionStorage.getItem("activeUser") || "";
      
        this.disablewhileProcessing = true;
        const req = {
          id: item.id,
          machine_id: item.machine_id,
          updated_by: updated_user,
          user_id: item.user_id,
          duration: item.duration,
          time_to_receive_mail: item.time_to_receive_mail,
          active: status
        };
  
        this.showLoader = true;
        let config = {
          method: "post",
          url: `${this.$config.backend_url}/UpdateSensorMailerData`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
          data: req,
        };
        this.noteLastAPICallTime();
        axios(config)
          .then((response) => {
            this.showLoader = false;
            if (response.data.status == "S") {
              document.querySelector("#sucessAlert").style.display = "block";
              this.setGridData();
              this.disablewhileProcessing = false;
            }
          })
          .catch((error) => {
            this.showLoader = false;
            if (error.response && error.response.status === 401) {
              sessionStorage.clear();
              router.push("/login");
            } else {
              document.querySelector("#errorAlert").style.display = "block";
              console.log("axios error", error.message);
              this.disablewhileProcessing = false;
            }
          });
      },

      setGridData: function() {
        this.headersData = [
          {
            text: "Machine",
            value: "machine_name",
            sortable: true,
          },
          {
            text: "User Name",
            value: "username",
            align: "start",
            sortable: true,
          },
          {
            text: "Email",
            value: "email",
            align: "start",
            sortable: true,
          },
          {
            text: "Duration",
            value: "duration",
            sortable: true,
          },
          {
            text: "Time to Receive Mail",
            value: "time_to_receive_mail",
            sortable: true,
          },
          { text: "Status", value: "active", sortable: true },  
          { text: "Actions", value: "actions", sortable: true },
        ];
        let config = {
          method: "get",
          url: `${this.$config.backend_url}/getSensorMailerData`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        };
        this.showLoader = true;
  
        this.noteLastAPICallTime();
        axios(config)
          .then((response) => {
            this.sensorMailersData = response.data.data;
            let result = [];  
            for (let i in response.data) result.push([i, response.data[i]]);
            this.dataDownload = result[0][1];
            this.showLoader = false;
          })
          .catch((error) => {
            this.showLoader = false;
            if (error.response && error.response.status === 401) {
              sessionStorage.clear();
              router.push("/login");
            } else if (
              error.response &&
              error.response.status === 400 &&
              error.response.data.message ===
                "This Password is not allowed, Choose different password."
            ) {
              alert(error.response.data.message);
            } else {
              alert("internal error");
              console.log("axios error", error.message);
            }
          });
      },
  
      editItem(item) {
        this.disableMachine =true
        this.isEdit = true;
        this.editedIndex = this.sensorMailersData.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
        this.editedItem.userSelection = item.user_id;
      },
  
      close() {
        this.dialog = false; 
        this.$refs.form.resetValidation();
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
  
      save() {
 
        let updated_user = sessionStorage.getItem("activeUser") || "";
        let user = sessionStorage.getItem("activeUser") || "";
        let req = {
          id: this.isEdit ? this.editedItem.id : undefined,
          machine_id: this.editedItem.machine_id,
          created_by: this.isEdit ? undefined : user,
          updated_by: this.isEdit ? updated_user : undefined,
          user_id: this.editedItem.user_id,
          duration: this.editedItem.duration,
          time_to_receive_mail: this.editedItem.time_to_receive_mail,
          active: this.editedItem.active,
        };
        let url = this.isEdit
          ? `${this.$config.backend_url}/UpdateSensorMailerData`
          : `${this.$config.backend_url}/SensorMailerDataEntry`;
        this.showLoader = true;
        let config = {
          method: "post",
          url: url,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
          data: req,
        };
        this.noteLastAPICallTime();
        axios(config)
          .then((response) => {
            this.showLoader = false;
            this.$refs.form.resetValidation();
            if (response.data.status == "S") {
              document.querySelector("#sucessAlert").style.display = "block";
              this.setGridData();
            }
          })
          .catch((error) => {
            this.showLoader = false;
            if (error.response && error.response.status === 401) {
              sessionStorage.clear();
              router.push("/login");
            } else {
              document.querySelector("#errorAlert").style.display = "block";
              console.log("axios error", error.message);
            }
          });
        this.close();
      },
    },
  };
  </script>
  <style scoped>
  #sucessAlert {
    display: none;
  }
  #errorAlert {
    display: none;
  }
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
  
  .v-data-table__wrapper
    > table
    > tbody
    > tr:not(:last-child)
    > td:not(.v-data-table__mobile-row) {
    border-right: thin solid rgba(0, 0, 0, 2) !important;
  }
  
  .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:not(:last-child)
    > th:not(.v-data-table__mobile-row) {
    border-right: thin solid rgba(0, 0, 0, 2);
  }
  </style>
  